import { Link } from 'react-router-dom';
import { movieStats, categories } from '@/mocks/movies';
import { newsList } from '@/mocks/news';

const stats = [
  { label: '收录影片', value: `${movieStats.total}`, suffix: '部' },
  { label: '影片分类', value: `${categories.length}`, suffix: '个' },
  { label: '行业资讯', value: `${newsList.length}`, suffix: '篇' },
  { label: '更新日期', value: '10.18', suffix: '' },
];

export default function IntroBand() {
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 rounded-lg border border-background-800 bg-background-900 p-6 md:p-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16">
        <div>
          <p className="flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.28em] text-accent-500">
            <span className="inline-block h-px w-6 bg-accent-500/70" />
            About the site
          </p>
          <h2 className="mt-3 text-2xl font-bold leading-snug text-foreground-50 md:text-3xl">
            一个把资料整理清楚的
            <br className="hidden sm:block" />
            日韩影视内容索引
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-[15px]">
            日韩成人电影不是播放平台。我们把影片的基本资料、题材分类、演职人员与剧情简介整理成可检索的条目，帮助成年观众在决定观看之前，先了解一部作品讲的是什么。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            站内所有条目均为演示用虚构内容，影片封面为艺术化示意图。我们不提供播放、下载、购买或任何形式的交易入口，也没有会员体系与付费内容。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解本站定位
              <i className="ri-arrow-right-line text-sm" />
            </Link>
            <Link
              to="/search"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700 px-4 py-2.5 text-xs text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              搜索影片与资讯
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex flex-col justify-between rounded-lg border border-background-800 bg-background-950/60 p-4 md:p-5"
            >
              <p className="text-xs text-foreground-600">{item.label}</p>
              <p className="mt-4 font-label text-3xl font-bold tracking-tight text-foreground-50 md:text-4xl">
                {item.value}
                <span className="ml-1 text-sm font-medium text-foreground-500">{item.suffix}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}